import { useMutation, useQuery } from "@tanstack/react-query";

import {
  fetchProcessedFile,
  fetchUploadHistory,
  uploadScriptFile,
} from "clients/uploadServiceClient";
import { MINUTE } from "constants/queryCacheTimes";

export { fetchProcessedFile } from "clients/uploadServiceClient";

export const useUploadFileService = () =>
  useMutation({ mutationFn: uploadScriptFile });

export const useUploadProductOffering = () =>
  useMutation({
    mutationFn: (payload) =>
      uploadFile("/api/product-offerings/upload", payload),
    onSuccess: (data) => {
      if (data.signedUrl) {
        window.location.href = data.signedUrl;
      } else {
        alert("Upload successful, but no download link received.");
      }
    },
    onError: (error) => {
      console.error("Error uploading product offering:", error.message);
    },
  });

export const useUploadFeatureOffering = () =>
  useMutation({
    mutationFn: (payload) =>
      uploadFile("/api/feature-offerings/upload", payload),
    onSuccess: (data) => {
      if (data.signedUrl) {
        window.location.href = data.signedUrl;
      } else {
        alert("Upload successful, but no download link received.");
      }
    },
    onError: (error) => {
      console.error("Error uploading feature offering:", error.message);
    },
  });

export const getHistoryQueryKey = (user_id) => ["history", user_id];

export const useFetchHistory = (user_id) =>
  useQuery({
    queryKey: getHistoryQueryKey(user_id),
    queryFn: () => fetchUploadHistory(user_id),
    enabled: Boolean(user_id),
    staleTime: 5 * MINUTE,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });

export const useFetchProcessedFile = (fileId) => {
  const query = useQuery({
    queryKey: ["processedFile", fileId],
    queryFn: () => fetchProcessedFile(fileId),
    enabled: !!fileId,
  });

  return {
    ...query,
    fetchProcessedFile,
  };
};
